<template>
  <div class="p-4 md:p-6 max-w-5xl mx-auto">
    <div class="mb-4">
      <router-link
        to="/teachers"
        class="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-800 font-medium"
      >
        <i class="fa-solid fa-arrow-left mr-2"></i>
        Volver a docentes
      </router-link>
    </div>

    <h1 class="text-2xl font-bold text-gray-800 mb-6">Horario del docente</h1>

    <TeacherSchedule v-if="teacherId" :teacher-id="teacherId" />
  </div>
</template>

<script>
import TeacherSchedule from '@/components/schedule/TeacherSchedule.vue'

export default {
  name: 'TeacherScheduleView',
  components: { TeacherSchedule },
  computed: {
    teacherId() {
      return this.$route.params.teacher_id
    },
  },
}
</script>
